<script>
// @ is an alias to /src
import Hero from "@/components/media/Hero.vue";
import Slider from "@/components/media/Slider.vue";
import Gallery from "@/components/media/Gallery.vue";
import Faq from "@/components/Faq.vue";
//Components
import Search from "@/views/home/components/Search.vue";
import SelectiveProcess from "@/views/home/components/SelectiveProcess.vue";
import Inclusion from "@/views/home/components/Inclusion.vue";
// ======================
import Testimonial from "@/views/home/components/Testimonial.vue";
import Benefits from "@/views/home/components/Benefits.vue";
export default {
  name: "Home",

  data() {
    return {};
  },

  head() {
    return this.$head({
      title: "",
    });
  },

  computed: {
    slide() {
      return [
        { img: "pagina_principal_1.jpg" },
        { img: "pagina_principal_2.jpg" },
        { img: "pagina_principal_3.jpg" },
      ];
    },
    valores() {
      return this.$store.state.values;
    },

    teams() {
      return this.$store.state.teams;
    },

    conquistas() {
      return this.$store.state.conquistas;
    },

    faqItems() {
      return this.$store.state.faqItems;
    },
  },

  components: {
    Hero,
    Slider,
    Gallery,
    Search,
    SelectiveProcess,
    Faq,
    Testimonial,
    Benefits,
    Inclusion,
  },

  mounted() {
    this.$store.dispatch("opportunities/setRIOpportunities");
  },
};
</script>

<template>
  <section>
    <div class="home">
      <Hero slideTitle="" :slide="slide" height="90vh" />
      <Search />
      <SelectiveProcess />
      <Benefits />
      <Inclusion />
      <Testimonial />
      <!-- <Faq /> -->
    </div>
  </section>
</template>

